import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';


function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.experimentPoster[ownProps.id-1].type
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
